import { createFileRoute } from "@tanstack/react-router";
import { SharedRunViewer } from "@/components/run-viewer/SharedRunViewer";
import { buildMetaTags } from "@/lib/seo/meta";

export const Route = createFileRoute("/share/$token")({
	head: () => ({
		meta: buildMetaTags({
			title: "Shared Conversation",
			description:
				"See what autonomous AI teammates can do — view this shared conversation from m8tes.ai.",
		}),
	}),
	component: SharedRunPage,
});

function SharedRunPage() {
	const { token } = Route.useParams();
	return <SharedRunViewer shareToken={token} />;
}
